import { INSURANCE_TYPES } from '../../../../../../constants';
import { INSURANCE_TYPE_TAB_IDS, INSURANCE_TYPE_TITLES } from '../../forms/insurance/constants';
import { isExtractionInProgress } from '../../forms/insurance/hooks/utils';

import type { OnboardingTabId } from '../../../types';
import type { TabConfig } from '../../../../common/types';
import type { InsuranceExtractionMap } from '../../forms/insurance/hooks/types';
import type { InsuranceType } from '../../../../../../utils/types';

function getInsuranceTypeForTab(tabId: OnboardingTabId): InsuranceType | null {
  for (const insuranceType of [INSURANCE_TYPES.PRIMARY, INSURANCE_TYPES.SECONDARY] as const) {
    if (INSURANCE_TYPE_TAB_IDS[insuranceType] === tabId) {
      return insuranceType;
    }
  }
  return null;
}

export function isExtractionBlockingTab(
  tabId: OnboardingTabId,
  extraction: InsuranceExtractionMap,
): boolean {
  const insuranceType = getInsuranceTypeForTab(tabId);
  if (insuranceType == null) return false;
  const entry = extraction[insuranceType];
  return entry != null && (isExtractionInProgress(entry.status) || entry.needsReview === true);
}

export function getConcludeErrorPageLabel(tab: TabConfig<OnboardingTabId>): string {
  const insuranceType = getInsuranceTypeForTab(tab.id);
  if (insuranceType != null) {
    return INSURANCE_TYPE_TITLES[insuranceType];
  }
  return tab.label;
}
